import { ColorPieChart, Number, PieChart, Root } from './CustomPieChart.styles';

import { RawPercentageProps } from './types';
import { useAppSelector } from 'store/hooks';

export const PercentPieChart = ({ color, sizes, sm, rawPercentage }: RawPercentageProps) => {
	const { isPunchup } = useAppSelector((state) => state.auth);
	const percentage = Math.round(rawPercentage * 100);

	const getPrimaryPercentage = () => {
		if (percentage === 100) return 100;
		if (percentage === 0) return 0;
		if (percentage > 10) return percentage - 7;
		return 4;
	};
	const primayPercentage = getPrimaryPercentage();
	const secondaryPercentage = primayPercentage === 0 ? 100 : 100 - primayPercentage - 7;

	return (
		<Root>
			{primayPercentage > 0 && (
				<ColorPieChart color={color} iconWidth={sizes.iconSize} percentage={primayPercentage} sm={sm} />
			)}
			<PieChart
				color={secondaryPercentage > 0 ? '#4A4a4a' : 'transparent'}
				iconWidth={sizes.iconSize}
				percentage={secondaryPercentage}
				sm={sm}
			>
				<Number fontSize={sizes.fontSize} isPunchup={isPunchup}>
					{`${percentage}%`}
				</Number>
			</PieChart>
		</Root>
	);
};
